import React from 'react'
import styled from '@emotion/styled'
import { Label } from 'components/chec'

const withStyle = (WrappedOutputQuery) => {
  const StyledOutputQuery = styled(WrappedOutputQuery)(
    (props) => `
      margin-top:1em;
    `
  )

  return (props) => <StyledOutputQuery {...props} />
}

export const StyledLabel = styled(Label)`
  display: block;
`

export default withStyle
